import { render } from "./TagPage.vue?vue&type=template&id=06cbfaa6&scoped=true"
import script from "./TagPage.vue?vue&type=script&lang=js"
export * from "./TagPage.vue?vue&type=script&lang=js"

import "./TagPage.vue?vue&type=style&index=0&id=06cbfaa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cbfaa6"]])

export default __exports__